import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";
import { toast } from "react-toastify";
import SimpleMap from "../../../../components/gmaps";
const TransferReceiptFrom = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const [loading, setLoading] = useState(false);

  const [employeelist, setEmployeelist] = useState(null);
  const [assignEmployeeId, setAssignEmployeeId] = useState();

  const [vehiclelist, setVehiclelist] = useState(null);
  const [vmerId, setvmerId] = useState();

  const [productData, setProductData] = useState([]);
  const [productId, setProductId] = useState();
  const [goodsTransferNoList, setGoodsTransferNoList] = useState(null);
  const [availableAmount, setavailableAmount] = useState();
  const [unitId, setunitId] = useState();
  const [goodsTransferId, setGoodsTransferId] = useState();

  const [warehosuelatLong, setWarehosuelatLong] = useState({
    lat: "",
    lng: "",
  });

    useEffect(() => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          //console.log(lat, long);
          setWarehosuelatLong({ lat, lng });
        },
        (error) => {
          console.error(error);
        }
      );
    }, []);

  const [warehosuelatLongstr, setwarehosuelatLongstr] = useState();

  const [latLongclose, setLatLongclose] = useState(false);

  const [warehosuedata, setWarehosuedata] = useState([]);
  const [warehouseId, setWarehouseId] = useState();
  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  ); // ;

  const handleLatLong = () => {
    setLatLongclose(true);
  };

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const [estimatedDeliveryDate, setestimatedDeliveryDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const { sendRequest: postProcurementOfficer } = useHttp();

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getVehicle } = useHttp();

  useEffect(() => {
    getVehicle(
      {
        url: "/api/vehicleMachineEquipRegistratn/",
      },
      (res) => {
        if (res) {
          var vehicle = res.filter((x) => x.vmeClassific == "Vehicle");
          //console.log(vehicle);
          setVehiclelist(vehicle);
        }
      }
    );
  }, [getVehicle]);

  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //console.log(res);

          var fromwarehosueId = parseInt(localStorage.getItem("warehouseId"));
          var warehouse = res.filter((item) => item.id != fromwarehosueId);
          setWarehosuedata(warehouse);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getproduct } = useHttp();

  const getProductDetail = () => {
    getproduct(
      {
        url: "/api/product/",
      },
      (res) => {
        if (res) {
          //console.log("product", res);
          setProductData(res);
        }
      }
    );
  };

  useEffect(() => {
    getProductDetail();
  }, [getproduct]);

  const { sendRequest: GoodsTransferNo } = useHttp();

  const FillGoodsTransferNo = (_empId, _warehouseId) => {
    GoodsTransferNo(
      {
        url: `/api/goodsTransferNoForTransferGoods/?orgId=${localStorage.getItem(
          "orgId"
        )}&employeeId=${_empId}&warehouseId=${_warehouseId}`,
        method: "Get",
      },
      (data) => {
        setGoodsTransferNoList(data);
        console.log("data", data);
      }
    );
  };

  const { sendRequest: getTransferReceiptData } = useHttp();

  const FillTransferReceiptData = (goodsTransferId) => {
    var vmerId = 0;

    var GoodsTransferobj = goodsTransferNoList.filter(
      (item) => parseInt(item.goodsTransferId) == parseInt(goodsTransferId)
    );
    if (GoodsTransferobj && GoodsTransferobj.length > 0) {
      vmerId = GoodsTransferobj[0].vehicleId;
    }
    setvmerId(vmerId);
    LoadVehicleData(vmerId);
    getTransferReceiptData(
      {
        url: `/api/getTransferReceiptData/?orgId=${localStorage.getItem(
          "orgId"
        )}&goodsTransferId=${goodsTransferId}`,
        method: "Get",
      },
      (data) => {
        setProductData(data);
        setProductDetails(data);
      }
    );
  };

  const { sendRequest: getAvailableStock } = useHttp();

  const loadStockData = (id) => {
    productRef.current.productSubType.value = "";
    productRef.current.productType.value = "";

    var itemlist = productData.filter((item) => item.productId == id);
    var selectedItem = itemlist[0];

    productRef.current.productSubType.value = selectedItem.productSubTypeName;
    productRef.current.productType.value = selectedItem.productTypeName;
    const data = {
      warehouseId: localStorage.getItem("warehouseId"),
      productId: id,
    };

    getAvailableStock(
      {
        url: "/api/getAvailableStock/",
        method: "POST",
        body: data,
      },
      (myres) => {
        var res=myres.data

        //console.log("getAvailableStock", res);
        productRef.current.availableQuantity.value = res.availableQty;
        productRef.current.productUnit.value = res.unitName;
        productRef.current.unitId.value = res.unitId;
        productRef.current.availableAmount.value = res.availableAmount;
        setavailableAmount(res.availableAmount);
        setunitId(res.unitId);
      }
    );
  };

  const LoadVehicleData = (id) => {
    var itemlist = vehiclelist.filter((item) => item.vmerId == id);
    var selectedItem = itemlist[0];

    frmRef.current.driverName.value = itemlist[0].assignedPersonDriverName;
    frmRef.current.driverContactNo.value = itemlist[0].assignedPersonContactNo;
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (productDetails.length == 0) {
      toast.success("Please enter at least one product!");
      return;
    }

    setLoading(true);

    const data = {
      goodsTransferReceiptDate: moment(frmRef.current.date.value).format(
        "DD/MM/YYYY"
      ),
      goodsTransferToOfficerEmpId: assignEmployeeId,
      timeStamp: frmRef.current.time_stamp.value,
      productDetails: productDetails,
      goodsTransferId: goodsTransferId,
      vehicleId: vmerId,
      receiptWarehouseId: warehouseId,
      driverName: frmRef.current.driverName.value,
      driverContactNo: frmRef.current.driverContactNo.value,
      endMeterReading: frmRef.current.endMeterReading.value,
      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId,
    };

    // if (props.update) {
    //   data["gtProcurementId"] = props.update.gtProcurementId;
    // }
    postProcurementOfficer(
      {
        url: "/api/transferReceipt/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Goods transfer note ${props.update ? "updated" : "added!"}`
        );

        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      frmRef.current.date.value = moment(props.update.gtProcurementDate).format(
        "YYYY-MM-DD"
      );
      frmRef.current.emp_id.value = props.update.procurementOfficerEmpId;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");
      setProductDetails(props.update.productDetails);
      frmRef.current.gate_pass_id.value = props.update.gatepassId;
      frmRef.current.vehicle_id.value = props.update.vehicleId;
      frmRef.current.driver_name.value = props.update.driverName;
      frmRef.current.driver_contact_number.value = props.update.driverContactNo;
      frmRef.current.start_meter_reading.value = props.update.startMeterReading;
      frmRef.current.end_meter_reading.value = props.update.endMeterReading;
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  const submitProduct = (e) => {
    e.preventDefault();
    var itemlist = productData.filter((item) => item.productId == productId);
    var selectedItem = itemlist[0];

    var productId1 = productId;
    var itemId = selectedItem.itemId;
    var productName = selectedItem.productName;
    var productSubType = productRef.current.productSubType.value;
    var productType = productRef.current.productType.value;
    var availableQuantity = productRef.current.availableQuantity.value;
    var unit = productRef.current.productUnit.value;
    var unitId1 = unitId;
    var availableAmount1 = availableAmount;
    var itemQuantity = productRef.current.itemQuantity.value;

    var pdlist = productDetails.filter((item) => item.productId == productId1);

    if (parseFloat(itemQuantity ?? 0) <= 0) {
      toast.success("Please enter product quantity", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (pdlist.length != 0) {
      toast.success("Product already present into the list", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        productId: productId1,
        itemId: itemId,
        productName: productName,
        productSubType: productSubType,
        productType: productType,
        availableQuantity: availableQuantity,
        unit: unit,
        unitId: unitId1,
        availableAmount1: availableAmount1,
        itemQuantity: itemQuantity,
        itemQuantityBal: itemQuantity,
        productCost: 0,
        remark: frmRef.current.remark.value,
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        // itemType: productRef.current.itemType.value,
        // itemCategory: productRef.current.itemCategory.value,
        // itemQuantity: productRef.current.itemQuantity.value,
        // unit: productRef.current.unit.value,
        // itemUnitPrice: productRef.current.itemUnitPrice.value,
        // rate: productRef.current.rate.value,
        // currency: productRef.current.currency.value,
        // totalAmount: productRef.current.totalAmount.value,
      },
    ]);

    setProductId(0);

    productRef.current.productSubType.value = "";
    productRef.current.productType.value = "";
    productRef.current.availableQuantity.value = "";
    productRef.current.productUnit.value = "";
    setunitId(0);
    setavailableAmount(0);
    productRef.current.itemQuantity.value = "0";
    //console.log(productDetails);
  };
  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const handleValidateQuantityChange = (event) => {
    var validator = new RegExp("^[0-9.]*$");

    var qtyvalid = validator.test(event.target.value);
    //console.log("handleValidateQuantityChange");
    //console.log(qtyvalid);
    if (qtyvalid) {
      var quantity = parseFloat(event.target.value);

      var totalquantity = parseFloat(
        productRef.current.availableQuantity.value
      );

      if (quantity > totalquantity) {
        event.target.value = 0;
        toast.success("Please enter quanitty less than total quantity", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
      event.target.value = 0;
    }
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  return (
    <>
      <Modal isOpen={close} style={customModalStyles}>
        <div>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Product Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="tableheaderrowview">
                    <th>Sr. No</th>
                    <th>Item Id</th>
                    <th>Product Name</th>

                    <th>Item SubType</th>
                    <th>Item Type</th>
                    <th>Item Quantity</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  {productDetails &&
                    productDetails.map((itm, i) => {
                      return (
                        <tr key={i.srno}>
                          <td>{i + 1}</td>
                          <td>{itm.itemId}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.productSubType}</td>
                          <td>{itm.productTypeName}</td>
                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unitAbbreviation}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-2"></div>

              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    productDetails.map((x) => (x["isSave"] = true));
                    setClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
        </div>
      </Modal>

      {latLongclose && (
        <Modal onClose={setLatLongclose}>
          <SimpleMap
            lat={warehosuelatLong.lat}
            lng={warehosuelatLong.lng}
            set={setWarehosuelatLong}
            close={setLatLongclose}
          />
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Transfer Receipt Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-2">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Trasnfer To Employee"}</label>
                      <select
                        id="emp_id"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                          FillGoodsTransferNo(e.target.value, warehouseId);
                        }}
                      >
                        <option selected value="0">
                          --Select Employee--
                        </option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"warehouseId"}>{"Warehouse"}</label>

                      <select
                        id="warehouseId"
                        className="form-control"
                        ref={(el) => (frmRef.current["warehouseId"] = el)}
                        value={warehouseId}
                        required
                        onChange={(e) => {
                          setWarehouseId(e.target.value);
                          FillGoodsTransferNo(assignEmployeeId, e.target.value);
                        }}
                      >
                        <option selected value="0">
                          --Select Warehouse--
                        </option>
                        {warehosuedata &&
                          warehosuedata.map((x) => (
                            <option key={x.id} warehouse-id={x.id} value={x.id}>
                              {x.name} {}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">&nbsp;</div>
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"warehouseId"}>
                        {"Goods Transfer No"}
                      </label>

                      <select
                        id="warehouseId"
                        className="form-control"
                        ref={(el) => (frmRef.current["warehouseId"] = el)}
                        value={goodsTransferId}
                        required
                        onChange={(e) => {
                          setGoodsTransferId(e.target.value);
                          FillTransferReceiptData(e.target.value);
                        }}
                      >
                        <option selected value="0">
                          --Select Goods Trasnfer No--
                        </option>
                        {goodsTransferNoList &&
                          goodsTransferNoList.map((x) => (
                            <option
                              key={x.goodsTransferId}
                              warehouse-id={x.goodsTransferId}
                              value={x.goodsTransferId}
                            >
                              {x.goodsTrasnferNo} {}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label> {"Product Details"}</label>
                      <br />
                      <button
                        className="btn btn-sm  btn-success mx-2 my-2"
                        formNoValidate="True"
                        onClick={(e) => {
                          e.preventDefault(false);
                          // productDetails &&
                          //   setProductDetails((items) =>
                          //     items.filter((x) => x.isSave)
                          //   );
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"vehicle_id"}>{"Vehicle id"}</label>

                      <select
                        id="vmerId"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["vmerId"] = el)}
                        value={vmerId}
                        onChange={(e) => {
                          setvmerId(e.target.value);
                          LoadVehicleData(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          --Select Vehicle --
                        </option>
                        {vehiclelist &&
                          vehiclelist.map((x) => (
                            <option
                              key={x.vmerId}
                              vmer-id={x.vmerId}
                              value={x.vmerId}
                            >
                              {x.vmeNo}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">&nbsp;</div>
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"driverName"}>{"Driver Name"}</label>
                      <input
                        type={"text"}
                        id={"driverName"}
                        required
                        ref={(el) => (frmRef.current["driverName"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"driverContactNo"}>
                        {"Vehicle Driver Contact Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"driverContactNo"}
                        required
                        ref={(el) => (frmRef.current["driverContactNo"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"endMeterReading"}>
                        {"End Meter Reading"}
                      </label>
                      <input
                        type={"text"}
                        id={"endMeterReading"}
                        ref={(el) => (frmRef.current["endMeterReading"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4"> </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default TransferReceiptFrom;
